const Notifications = () => {
  return 'Coming soon';
};

export default Notifications;
